import { createTheme } from '@mui/material/styles';
import { designTokens } from './designTokens';

export const appTheme = createTheme({
  palette: designTokens.palette,
  typography: designTokens.typography as any,
  shape: designTokens.shape,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 32,
          textTransform: 'none',
          fontWeight: 600,
        },
        containedPrimary: {
          boxShadow: '0px 4px 16px 0px rgba(0,0,0,0.1)',
        },
      },
    },
  },
});
